<template>
  <div id="quitApply" class="only-content">
    <div class="header">
      <Form
        :label-width="90"
        inline
        :model="params"
        ref="paramsForm"
        style="width: 100%"
      >
        <Row>
          <Col span="5">
            <FormItem label="业务员" prop="nameOrCode">
              <Input
                style="width: 162px"
                v-model.trim="params.nameOrCode"
                placeholder="请输入业务员姓名/代码"
              />
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem label="所属机构" prop="deptCode">
              <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="params.deptCode"
              >
                <Option
                  v-for="item in transForList.customList"
                  :value="item.deptCode"
                  :key="item.id"
                  placeholder="请选择机构名称/代码"
                  >{{ item.deptName }} / {{ item.deptCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem label="审核状态" prop="status">
              <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="params.status"
                placeholder="请选择审核状态"
              >
                <Option value="0">通过</Option>
                <Option value="1">未通过</Option>
                <Option value="2">审批中</Option>
                <!-- <Option value="3">待提交</Option> -->
                <Option value="4">已撤回</Option>
                <!-- <Option value="6">已失效</Option> -->
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem label="职级名称" prop="rankCode">
              <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="params.rankCode"
                placeholder="请选择职级"
              >
                <Option
                  :value="item.rankCode"
                  v-for="item in rankTypeList"
                  :key="item.id"
                  >{{ item.rankName }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col style="float: right">
            <Button type="primary" @click="search">查询</Button>
            <Button @click="reset">重置</Button>
          </Col>
        </Row>
        <div style="margin-bottom: 20px">
          <div id="moreBtn" class="searchUpDownBtn" style="margin-bottom: 6px">
            <Icon type="ios-arrow-down" @click="moreFun()" />
            <span @click="moreFun()">更多条件</span>
          </div>
          <div id="moreCondition">
            <Row>
              <!-- <Col span="5">
                        <FormItem label="来源" prop="status">
                            <Select @on-open-change="selectUpDown" v-model="params.applyFrom" placeholder="请选择来源">
                                <Option value="0">异动申请</Option>
                                <Option value="1">考核结果</Option>
                            </Select>
                        </FormItem>
                    </Col> -->
              <!-- <Col span="5">
                                <FormItem label="离职日期" prop="date2">
                                    <DatePicker transfer type="date" v-model="params.quitDate"
                                                @on-change="(val) => params.quitDate = val"
                                    placeholder="请选择离职日期" ></DatePicker>
                                </FormItem>
                            </Col> -->
              <Col span="10">
                <FormItem label="日期类型" prop="dateType">
                  <Select
                    clearable
                    transfer
                    @on-open-change="selectUpDown"
                    v-model.trim="params.dateType"
                    placeholder="请选择日期类型"
                  >
                    <Option value="1">提交日期</Option>
                    <Option value="2">审批日期</Option>
                  </Select>
                  <DatePicker
                    transfer
                    type="daterange"
                    placeholder="请选择日期范围"
                    style="margin-left: 10px"
                    :value="params.date"
                    @on-change="
                      (date) => {
                        params.date = date;
                        params.startDate = date[0];
                        params.endDate = date[1];
                      }
                    "
                  ></DatePicker>
                  <!-- <span style="display: inline-block;margin-left: 10px">
                                        <DatePicker :value="params.startDate" @on-change="(date)=>{params.startDate=date}"></DatePicker>
                                    </span>
                                    <span style="display: inline-block;margin-left: 10px">
                                        <DatePicker :value="params.endDate" @on-change="(date)=>{params.startDate=date}"></DatePicker>
                                    </span> -->
                </FormItem>
              </Col>
            </Row>
          </div>
          <div id="upBtn" class="searchUpDownBtn">
            <Icon type="ios-arrow-up" @click="upFun()" />
            <span @click="upFun()">收起</span>
          </div>
        </div>

        <!-- <Row>
                    <Col  style="text-align: right">
                        <FormItem>
                            <Button type="primary" @click="search">查询</Button>
                            <Button @click="reset">重置</Button>
                        </FormItem>
                </Row> -->
      </Form>
    </div>
    <div style="margin-bottom: 15px">
      <Button
        type="primary"
        @click="quitApply('add')"
        v-show="button.moveApply_addQuit"
        >新增申请</Button
      >
      <!-- <Button type="success" @click="agentSbumit">一键提交</Button> -->
      <Button
        v-show="button.moveApply_withdraw"
        type="warning"
        @click="agentCancel"
        >一键撤回</Button
      >
    </div>
    <div>
      <primaryTable
        :columns="columns"
        :data="data"
        :total="total"
        :loading="tableLoading"
        @on-change="changePage"
        @on-page-size-change="changeSize"
      ></primaryTable>
    </div>

    <Modal
      class="Modal_html"
      title="离职申请"
      v-model.trim="quitModalFlag"
      width="1000"
      :footer-hide="isSee"
    >
      <Form
        ref="formValidate_leave"
        :model="formValidate_leave"
        :rules="ruleValidate_leave"
        :disabled="isSee"
        :label-width="120"
      >
        <!-- 基本信息 -->
        <Row>
          <!-- <h3 class="marginLeft30" style="margin-left:35px;margin-bottom: 10px">提交信息</h3> -->
          <Col span="12">
            <FormItem label="业务员" prop="agentCode">
              <!-- <InputModal
                :disabled="isReady"
                :rule="{
                  required: true,
                  message: ' 请选择业务员',
                  trigger: 'blur,change',
                }"
                value="agentCode"
                :ApiList="[
                  { agentCode: 'agentCode' },
                  { agentName: 'agentName' },
                  { rankCode: 'rankCode' },
                  { deptCode: 'customerCode' },
                  { areaCode: 'areaCode' },
                  { areaName: 'areaName' },
                  { teamInfoCode: 'teamInfoCode' },
                  { teamName: 'teamName' },
                  { groupCode: 'groupInfoCode' },
                  { groupName: 'groupInfoName' },
                  { deptName: 'customerName' },
                  { rankName: 'rankName' },
                  { areaName: 'areaName' },
                  { postName: 'postName' },
                  { postCode: 'postCode' },
                  { certificateNum: 'certificateNum' },
                ]"
                :form.sync="formValidate_leave"
              ></InputModal> -->
              <Select
                filterable
                transfer
                @on-open-change="selectUpDown"
                :disabled="isReady"
                clearable
                placeholder="请选业务员"
                v-model.trim="formValidate_leave.agentCode"
                @on-change="changePerson"
                v-if="!isReady"
              >
                <Option
                  :value="item.agentCode"
                  v-for="(item, index) in personList"
                  :key="index"
                  >{{ item.agentCode }} / {{ item.agentName }}</Option
                >
              </Select>
              <Input disabled v-else v-model.trim="agentCodeName" />
            </FormItem>
          </Col>
          <!-- <Col span="12">
            <FormItem label="业务员姓名" prop="agentName">
              <Input v-model.trim="formValidate_leave.agentName" disabled />
            </FormItem>
          </Col> -->
          <Col span="12">
            <FormItem label="职级" prop="rankCode">
              <Input
                type="text"
                disabled
                v-model="formValidate_leave.rankCodeAndName"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="所属机构" prop="deptCode">
              <Input
                type="text"
                disabled
                v-model="formValidate_leave.deptCodeAndName"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <!-- <Col v-show="channelType != 4" span="12">
            <FormItem label="营业区/代码" prop="areaCode">
              <Input
                type="text"
                disabled
                v-model="formValidate_leave.areaCodeAndName"
                placeholder="请输入"
              />
            </FormItem>
          </Col> -->
          <!-- <Col v-show="channelType == 4" span="12">
            <FormItem label="营业部/代码" prop="teamInfoCode">
              <Select
                transfer
                @on-open-change="selectUpDown"
                disabled
                clearable
                placeholder="请选择所属营业部"
                v-model.trim="formValidate_leave.teamInfoCode"
                @on-change="
                  (data) => {
                    getChild(data, 'groupList', this);
                  }
                "
              >
                <Option
                  :value="item.deptCode"
                  v-for="(item, index) in teamList"
                  :key="index"
                  >{{ item.deptName }} / {{ item.deptCode }}</Option
                >
              </Select>
            </FormItem>
          </Col> -->
          <Col span="12">
            <FormItem label="离职次数" prop="quitCount">
              <Input
                type="text"
                disabled
                v-model="formValidate_leave.quitCount"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="离职日期">
              <DatePicker
                transfer
                type="date"
                disabled
                v-model="formValidate_leave.changeQuitDTO.quitDate"
                clearable
                placeholder="请输入"
                @on-change="
                  (val) =>
                    (formValidate_leave.changeQuitDTO.quitDate =
                      val === '' ? '' : val)
                "
                style="width: 100%"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <FormItem label="离职原因" prop="changeQuitDTO.reason">
            <Input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              :disabled="isReady"
              v-model.trim="formValidate_leave.changeQuitDTO.reason"
              :maxlength="200"
              placeholder="请输入"
            />
          </FormItem>
        </Row>

        <Row>
          <FormItem label="附件">
            <RadioGroup
              :disabled="isReady"
              v-model="singleChange"
              @on-change="changeSelectPic"
            >
              <Radio label="0">单件</Radio>
              <Radio label="1">多件</Radio>
            </RadioGroup>
            <span>单张上传最大限制 5M，jpg、png、pdf格式</span>
            <!-- <div>
              <FormItem
                class="fileStyle"
                label="附件"
                prop="changeAttachmentDTO"
              > -->
            <div style="display: flex; flex-wrap: wrap">
              <span
                v-for="(item, index) in formValidate_leave.changeAttachmentDTO"
                :key="index"
              >
                <div class="demo-upload-list">
                  <img
                    :src="
                      $api.imgLoadUrl + item.filePath + '?sid=' + headers.sid
                    "
                  />
                  <div class="demo-upload-list-cover">
                    <Icon
                      type="ios-eye-outline"
                      @click.native="handleView(item)"
                    ></Icon>
                    <Icon
                      v-if="!isReady"
                      type="ios-trash-outline"
                      @click.native="delFormValidate_relationImage(item, index)"
                    ></Icon>
                  </div>
                </div>
                <div
                  style="text-align: center; width: 200px"
                  class="ellipsis"
                  :title="item.fileName"
                >
                  {{ item.fileName }}
                </div>
              </span>
            </div>
            <!-- </FormItem>
            </div> -->
            <div v-if="!isSee">
              <div
                v-show="
                  (singleChange == '0' &&
                    formValidate_leave.changeAttachmentDTO.length < 1) ||
                  (singleChange == '1' &&
                    formValidate_leave.changeAttachmentDTO.length < 20)
                "
              >
                <Upload
                  :multiple="singleChange == '0' ? false : true"
                  :max-size="singleChange == '0' ? '5012' : ''"
                  :before-upload="handleBeforeUpload"
                  :action="action"
                  ref="upload"
                  name="files"
                  :show-upload-list="false"
                  :format="['jpg', 'pdf', 'png']"
                  :headers="headers"
                  type="drag"
                  :on-success="handSuccess"
                  accept=".jpg,.pdf,.png"
                  :data="fileData"
                >
                  <div style="height: 90px">
                    <Icon
                      type="ios-cloud-upload"
                      size="22"
                      style="color: #3399ff"
                    ></Icon>
                    <p>支持jpg/png格式图片；支持PDF文件</p>
                  </div>
                </Upload>
              </div>
            </div>
          </FormItem>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="申请人" prop="createdUser">
              <Input
                type="text"
                v-model.trim="formValidate_leave.createdUser"
                placeholder="请输入"
                disabled
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="申请日期" prop="submitDate" disabled>
              <DatePicker
                transfer
                type="date"
                clearable
                :value="formValidate_leave.submitDate"
                :on-change="
                  (date) => {
                    formValidate_leave.submitDate = date;
                  }
                "
                placeholder="请输入"
                disabled
                style="width: 100%"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="cancel('formValidate_leave')">取消</Button>
        <Button
          :disabled="stopClickLogin"
          type="primary"
          @click="submit('0')"
          v-show="!isReady && !isEdit"
          >确认提交</Button
        >
        <!-- <Button
          type="primary"
          ghost
          @click="submit('1')"
          v-show="!isReady && !isEdit"
          >保存</Button
        > -->
        <Button
          :disabled="stopClickLogin"
          type="primary"
          @click="resubmit('0')"
          v-show="isEdit"
          >再次提交</Button
        >
      </div>
    </Modal>

    <Modal v-model.trim="auditModal" title="审批记录" width="900">
      <Row>
        <Col>
          <ModalLog
            :auditList="auditList"
            checkLogType="审批记录"
            :auditNo="auditNo"
          ></ModalLog>
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "quitApply",
  props: {
    /*  rankTypeList:{
                type:Array
            }, */
    headers: {
      type: Object,
    },
    sid: {
      type: String,
    },
    companyList: {
      type: Object,
    },
  },
  data() {
    /*  const dateChange = (rule, value, callback)=>{
                if(this.formValidate_leave.changeQuitDTO.quitDate && this.formValidate_leave.changeQuitDTO.applicationDate) {
                    if(this.formValidate_leave.changeQuitDTO.quitDate < this.formValidate_leave.changeQuitDTO.applicationDate) {
                        callback(new Error("离职申请日期不可晚于离职日期"))
                    } else {
                        callback()
                    }
                } else {
                    callback()
                }
            } */
    return {
      channelType: "",
      button: this.$store.state.app.button,
      //上传的文件类型
      fileData: {
        fileType: 5, //5代表离职
      },
      //上传前的文件列表
      auditModal: false,
      auditList: [],
      auditNo: "",
      //search 表单
      params: {
        quitDate: "",
        applicationDate: "",
        page: 1,
        pageSize: 10,
        nameOrCode: "",
        deptCode: "",
        status: "",
        applyFrom: "", //来源
        dateType: "",
        date: [],
        startDate: "",
        endDate: "",
        quitCount: "",
      },
      isReady: false,
      isSee: false,
      isEdit: false,
      action: this.$api.enclosureUpload,
      IsUpload: false,
      areaList: [],
      groupList: [],
      teamList: [],
      rankTypeList: [],
      customList: [],
      formValidate_leave: {
        submitDate: "",
        createdUser: "",
        changeType: 1, //异动类型 1-离职；2-关系；3-调动；4-合并 5 离职
        agentCode: "",
        agentName: "",
        deptCode: "",
        deptName: "",
        groupCode: "",
        groupName: "",
        teamInfoCode: "",
        teamName: "",
        areaCode: "",
        certificateNum: "",
        areaName: "",
        postName: "",
        postCode: "",
        rankName: "",
        rankCode: "",
        quitCount: "",
        changeQuitDTO: {
          applicationDate: "",
          quitDate: "",
          reason: "",
        },
        changeAttachmentDTO: [],
      },
      ruleValidate_leave: {
        agentCode: [
          { required: true, message: "请选择业务员", trigger: "change,blur" },
        ],
        deptCode: [
          { required: true, message: "请选择管理机构", trigger: "change,blur" },
        ],
        "changeQuitDTO.quitDate": [
          { required: true, message: "请输入离职日期", trigger: "change,blur" },
        ],
        "changeQuitDTO.applicationDate": [
          {
            required: true,
            message: "请输入离职申请日期",
            trigger: "change,blur",
          },
        ],
        rankCode: [
          { required: true, message: "请选择职级", trigger: "change,blur" },
        ],
        changeAttachmentDTO: [
          /*    {required:true} */
        ],
      },
      quitModalFlag: false,
      total: 0,
      data: [
        {
          auditCode: "123",
        },
      ],
      tableLoading: false,
      columns: [
        {
          title: "审批编号",
          key: "approvalId",
          align: "center",
          // fixed:'left',
          minWidth: 100,
          render: (h, p) => {
            return h(
              "a",
              {
                on: {
                  click: () => {
                    this.getDetail(p.row, true);
                  },
                },
              },
              p.row.approvalId
            );
          },
        },
        {
          title: "业务员代码 ",
          key: "agentCode",
          align: "center",
          minWidth: 110,
        },
        {
          title: "业务员名称 ",
          key: "agentName",
          align: "center",
          minWidth: 110,
        },
        // {
        //   title: "管理机构代码",
        //   key: "deptCode",
        //   align: "center",
        //   minWidth: 150,
        // },
        {
          title: "所属机构名称",
          key: "ascriptionDeptName",
          align: "center",
          minWidth: 150,
        },
        // {
        //   title: "营业区代码",
        //   key: "areaCode",
        //   align: "center",
        //   minWidth: 110,
        // },
        // {
        //   title: "营业区名称",
        //   key: "areaName",
        //   align: "center",
        //   minWidth: 110,
        // },
        // {
        //   title: "营业部代码",
        //   key: "teamInfoCode",
        //   align: "center",
        //   minWidth: 110,
        // },
        // {
        //   title: "营业部名称",
        //   key: "teamName",
        //   align: "center",
        //   minWidth: 110,
        // },
        // {
        //   title: "营业组代码",
        //   key: "groupCode",
        //   align: "center",
        //   minWidth: 110,
        // },
        // {
        //   title: "营业组名称",
        //   key: "groupName",
        //   align: "center",
        //   minWidth: 110,
        // },

        {
          title: "职级",
          key: "rankName",
          align: "center",
          minWidth: 100,
        },
        {
          title: "离职日期",
          key: "quitDate",
          align: "center",
          minWidth: 100,
        },
        {
          title: "离职次数",
          key: "quitCount",
          align: "center",
          minWidth: 100,
        },
        {
          title: "离职原因",
          key: "reason",
          align: "center",
          minWidth: 200,
          render: (h, params) => {
            let texts = "";
            if (params.row.reason) {
              if (params.row.reason.length > 30) {
                texts = params.row.reason.substring(0, 30) + "...";
              } else {
                texts = params.row.reason;
              }
            }
            return h(
              "Tooltip",
              {
                props: {
                  placement: "top",
                  transfer: true,
                },
              },
              [
                texts,
                h(
                  "span",
                  {
                    slot: "content",
                    style: {
                      whiteSpace: "normal",
                      wordBreak: "break-all",
                    },
                  },
                  params.row.reason
                ),
              ]
            );
          },
        },
        // {
        //   title: "申请来源",
        //   key: "applyFrom",
        //   align: "center",
        //   minWidth: 100,
        //   render: (h, params) => {
        //     let applyFrom = "";
        //     if (params.row.applyFrom == 0) {
        //       applyFrom = "异动申请";
        //     } else if (params.row.applyFrom == 1) {
        //       applyFrom = "考核结果";
        //     }
        //     return h("span", applyFrom);
        //   },
        // },
        {
          title: "申请提交人",
          key: "createdUser",
          align: "center",
          minWidth: 110,
        },
        {
          title: "提交日期",
          key: "submitDate",
          align: "center",
          minWidth: 100,
        },
        // {
        //   title: "审批日期",
        //   key: "approvalDate",
        //   align: "center",
        //   minWidth: 100,
        // },
        {
          title: "审批状态",
          key: "status",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            let status = "";
            if (params.row.status == 0) {
              status = "通过";
            } else if (params.row.status == 1) {
              status = "未通过";
            } else if (params.row.status == 2) {
              status = "审批中";
            } else if (params.row.status == 3) {
              status = "待提交";
            } else if (params.row.status == 4) {
              status = "已撤回";
            } else if (params.row.status == 5) {
              status = "通过";
            } else if (params.row.status == 6) {
              status = "已失效";
            }
            return h("span", status);
          },
        },
        {
          title: "操作",
          key: "",
          fixed: "right",
          align: "center",
          minWidth: 300,
          render: (h, params) => {
            return h("div", [
              this.button.moveApply_seeQuit
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      on: {
                        click: () => {
                          this.quitApply("see", params.row);
                        },
                      },
                    },
                    "查看"
                  )
                : "",
              this.button.moveApply_editQuit
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                        disabled:
                          params.row.status == 3 ||
                          params.row.status == 4 ||
                          params.row.status == 1
                            ? false
                            : true,
                      },
                      on: {
                        click: () => {
                          this.quitApply("edit", params.row);
                        },
                      },
                    },
                    "编辑"
                  )
                : "",
              this.button.moveApply_withdrawQuit
                ? h(
                    "Button",
                    {
                      props: {
                        type: "error",
                        size: "small",
                        disabled: params.row.status != 2 ? true : false,
                      },
                      on: {
                        click: () => {
                          this.withdraw(params.row);
                        },
                      },
                    },
                    "撤回"
                  )
                : "",
              this.button.moveApply_recordQuit
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        ghost: true,
                        size: "small",
                        disabled: params.row.approvalId ? false : true,
                      },
                      on: {
                        click: () => {
                          this.getAuditList(params.row);
                        },
                      },
                    },
                    "审批记录"
                  )
                : "",
            ]);
          },
        },
      ],
      personList: [], // 业务员list
      singleChange: "",
      agentCodeName: "", // 业务员名称编码
      stopClickLogin: false, //点击防抖
    };
  },
  created() {
    // 团险渠道 才有营业部。其余的需要删除
    this.channelType = sessionStorage.getItem("channelType");
    if (this.channelType == 4) {
      this.columns.splice(3, 2);
    } else {
      this.columns.splice(5, 2);
    }
    this.getPostList();
    // this.getLists();
    this.getLetterPage();
    /*    if (
      !this.button.moveApply_withdrawQuit &&
      !this.button.moveApply_editQuit &&
      !this.button.moveApply_recordQuit
    ) {
        this.columns.pop();
    } */
    // 业务员下拉选
    this.getExcludeInActivity();
  },

  methods: {
    handleView(item) {
      console.log(item);
      window.open(
        this.$api.imgLoadUrl + item.filePath + "?sid=" + this.headers.sid
      );
    },
    //删除文件
    delFormValidate_relationImage(item, index) {
      this.formValidate_leave.changeAttachmentDTO.splice(index, 1);
    },
    applicationDateChange(date) {
      this.formValidate_leave.changeQuitDTO.applicationDate = date;
    },
    quitDateChange(date) {
      console.log(date);
      this.formValidate_leave.changeQuitDTO.quitDate = date + "-01";
    },
    quitDateChange1(val) {
      console.log(val);
    },
    changeSize(size) {
      this.params.pageSize = size;
      this.getLetterPage();
    },
    //changepage
    changePage(page) {
      this.params.page = page;
      this.getLetterPage();
    },
    //删除文件
    delFormValidate_leaveImage() {
      this.formValidate_leave.changeAttachmentDTO = [];
    },
    //移出文件
    removeFIle(file, fileList) {
      console.log(file);
      console.log(fileList);
      this.formValidate_leave.changeAttachmentDTO = fileList || [];
    },
    handleBeforeUpload(file, fileList) {
      if (!this.formValidate_leave.changeAttachmentDTO) {
        this.formValidate_leave.changeAttachmentDTO = [];
      }
      console.log(this.formValidate_leave.changeAttachmentDTO);
      const check = this.formValidate_leave.changeAttachmentDTO.length < 20;
      if (!check) {
        this.$Message.error("最多上传20个文件");
      }
      return check;
    },
    //上传文件
    handSuccess(res, file, fileList) {
      if (res.content.success) {
        file.name = file.name.toLowerCase() || "";
        /*  if(file.name.indexOf('jpg')!=-1 ){
                        res.content.content.files[0].type='0'
                    }
                    if(file.name.indexOf('pdf')!=-1){
                        res.content.content.files[0].type='2'
                    }
                    if(file.name.indexOf('png')!=-1){
                        res.content.content.files[0].type='1'
                    } */
        res.content.content.files[0].type = "5"; //0：合同 1：资格证 2：培训 3：异动 4：入职资料 5：离职资料 6：其他
        // if(this.formValidate_leave.changeAttachmentDTO.length==3){
        //      this.$Message.error("最多可上传20个文件")
        //     return
        // } els
        // this.formValidate_leave.changeAttachmentDTO=res.content.content.files[0];
        if (res.content.content.files[0].fileName) {
          this.formValidate_leave.changeAttachmentDTO.push(
            res.content.content.files[0]
          );
        }
        this.formValidate_leave.changeAttachmentDTO.map(function (item) {
          item.url = item.filePath;
        });
        // this.formValidate_leave.changeAttachmentDTO.url=this.formValidate_leave.changeAttachmentDTO.filePath;
        console.log(this.formValidate_leave.changeAttachmentDTO);
      } else {
        this.$Message.error({
          content: res.content.resultMessage
            ? res.content.resultMessage
            : res.message,
          duration: 8,
        });
      }
    },
    //查询重置
    reset() {
      this.$refs.paramsForm.resetFields();
      this.params.date = [];
      this.params.startDate = "";
      this.params.endDate = "";
      this.params.applyFrom = "";
      this.search();
    },
    //查询search
    search() {
      this.params.page = 1;
      this.getLetterPage();
    },
    //获取离职申请page
    getLetterPage() {
      this.tableLoading = true;
      this.$api.getLetterPage(this.params).then((res) => {
        this.tableLoading = false;
        this.getExcludeInActivity();
        if (res.respCode == 0) {
          this.data = res.data.list;
          this.total = res.data.total;
        } else {
          console.log(res, "error");
        }
      });
    },
    //创建离职申请
    createLetter(params) {
      params.changeType = 1;
      this.$api.createLetter(params).then((res) => {
        if (res.respCode == 0) {
          this.search();
          this.$refs.formValidate_leave.resetFields();
          this.quitModalFlag = false;
        } else {
          this.$Message.error(res.resultMessage);
        }
      });
    },
    //提交
    submit(type) {
      this.stopClickLogin = true;
      setTimeout(() => {
        this.stopClickLogin = false;
      }, 2000);

      /*   if(this.formValidate_leave.changeAttachmentDTO.length==0){
                     this.$Message.error({
                         content:"请上传文件",
                         duration:5
                     })
                     return
                } */
      this.$refs.formValidate_leave.validate((item) => {
        if (item) {
          this.formValidate_leave.saveFlag = type;
          this.formValidate_leave.applyFrom = 0;
          console.log(this.formValidate_leave);
          this.createLetter(this.formValidate_leave);
        }
      });
    },
    colseModal() {
      this.quitModalFlag = false;
    },
    cancel(form) {
      this.isEdit = false;
      this.isReady = false;
      this.$refs[form].resetFields();
      this.colseModal();
    },

    //获取所有列表
    getLists() {
      this.$util.getDeptByLevel(this, "3", (e) => {
        this.customList = e;
      });
      this.$util.getDeptByLevel(this, "4", (e) => {
        this.areaList = e;
      });
      this.$util.getDeptByLevel(this, "5", (e) => {
        this.teamList = e;
      });
      this.$util.getDeptByLevel(this, "6", (e) => {
        this.groupList = e;
      });
    },
    //获取职级列表
    getPostList() {
      this.$api
        .getPostList({
          enableStatus: 0,
        })
        .then((res) => {
          if (res.respCode == 0) {
            console.log(res);
            this.rankTypeList = res.data;
          }
        });
    },

    //撤回
    withdraw(row) {
      this.$util.confirmDialog(
        this,
        "确认撤回",
        "确认撤回该条审批申请吗？一旦撤回将无法恢复!",
        (self) => {
          this.$api.withdraw({ id: row.id }).then((res) => {
            if (res.respCode == 0) {
              this.$Message.success("撤回成功");
              this.params.page = 1;
              this.getLetterPage();
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      );
    },

    //letterDetail 详情
    getDetail(row, type) {
      this.$api.letterDetail({ id: row.id }).then((res) => {
        if (res.respCode == 0) {
          this.isReady = type;
          this.formValidate_leave = res.data;
          this.agentCodeName =
            this.formValidate_leave.agentCode +
            "/" +
            this.formValidate_leave.agentName;
          this.formValidate_leave.approvalStatus = row.status;
          this.singleChange =
            res.data.changeAttachmentDTO.length > 1
              ? "1"
              : res.data.changeAttachmentDTO.length == 1
              ? "0"
              : "";
          // this.$refs.formValidate_leave.resetFields();
          this.quitModalFlag = true;
          this.$forceUpdate();
          console.log(this.singleChange, 343);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //审批记录
    getAuditList(row) {
      this.$api
        .getActivityHis({ processInstanceId: row.approvalId })
        .then((res) => {
          if (res.respCode == 0) {
            this.auditModal = true;
            this.auditNo = row.approvalId;
            this.auditList = res.data;
          } else {
            this.$Message.error(res.message);
          }
        });
    },

    //再次提交
    resubmit(type) {
      this.stopClickLogin = true;
      setTimeout(() => {
        this.stopClickLogin = false;
      }, 2000);
      this.isEdit = true;
      this.formValidate_leave.changeType = "1";
      this.formValidate_leave.applyFrom = 0;
      this.formValidate_leave.saveFlag = type;
      /*  if(this.formValidate_leave.changeAttachmentDTO.length==0){
                     this.$Message.error({
                         content:"请上传文件",
                         duration:5
                     })
                     return
                } */
      this.$refs.formValidate_leave.validate((item) => {
        if (item) {
          this.$api.resubmit(this.formValidate_leave).then((res) => {
            if (res.respCode == 0) {
              this.search();
              this.$refs.formValidate_leave.resetFields();
              this.quitModalFlag = false;
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      });
    },

    quitApply(type, params) {
      this.isSee = false;
      if (type === "add") {
        this.singleChange = "0";
        this.$refs.upload.clearFiles();
        this.formValidate_leave = {
          submitDate: "",
          createdUser: "",
          changeType: 1, //异动类型 1-离职；2-关系；3-调动；4-合并 5 离职
          agentCode: "",
          agentName: "",
          deptCode: "",
          deptName: "",
          groupCode: "",
          groupName: "",
          teamInfoCode: "",
          teamName: "",
          areaCode: "",
          certificateNum: "",
          areaName: "",
          postName: "",
          postCode: "",
          rankName: "",
          rankCode: "",
          quitCount: "",
          changeQuitDTO: {
            applicationDate: "",
            quitDate: "",
            reason: "",
          },
          changeAttachmentDTO: [],
        };
        this.isReady = false;
        this.isEdit = false;
        this.$refs.formValidate_leave.resetFields();
        this.quitModalFlag = true;
      } else if (type === "edit") {
        this.isReady = false;
        this.isEdit = true;
        // this.$refs.formValidate_leave.resetFields();
        this.quitModalFlag = true;
        this.getDetail(params, false);
      } else {
        this.isSee = true;
        // this.$refs.formValidate_leave.resetFields();
        this.quitModalFlag = true;
        this.getDetail(params, true);
      }
    },
    //获取业务员
    getExcludeInActivity() {
      this.$api.excludeInActivity({}).then((res) => {
        if (res.result == 0) {
          this.personList = res.content;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //一键提交
    agentSbumit() {},
    //一键撤回
    agentCancel() {
      this.$util.confirmDialog(
        this,
        "确认提示",
        "确认继续此项操作吗？确认后将无法撤回",
        () => {
          this.$api.batchQuit().then((res) => {
            if (res.result == 0) {
              this.params.page = 1;
              this.getLetterPage();
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      );
    },
    //附件单选
    changeSelectPic() {},
    //选择业务员
    changePerson(data) {
      let obj = this.personList.find((item) => item.agentCode == data);
      this.formValidate_leave.agentCode = data;
      this.formValidate_leave.agentName = obj.agentName;
      this.formValidate_leave.deptCode = obj.ascriptionDept;
      this.formValidate_leave.deptName = obj.ascriptionDeptName;
      // this.formValidate_leave.deptCode = obj.customerCode;
      // this.formValidate_leave.deptName = obj.customerName;
      this.formValidate_leave.areaCode = obj.areaCode;
      this.formValidate_leave.areaName = obj.areaName;
      this.formValidate_leave.rankCode = obj.rankCode;
      this.formValidate_leave.rankName = obj.rankName;
      this.formValidate_leave.quitCount = obj.quitCount;
      this.formValidate_leave.deptCodeAndName = obj.ascriptionDept
        ? obj.ascriptionDeptName + "/" + obj.ascriptionDept
        : "";
      // this.formValidate_leave.deptCodeAndName =
      //   obj.ascriptionDeptName && obj.ascriptionDept
      //     ? obj.ascriptionDeptName + "/" + obj.ascriptionDept
      //     : "";
      this.formValidate_leave.rankCodeAndName =
        obj.rankCode && obj.rankName ? obj.rankName + "/" + obj.rankCode : "";
      this.formValidate_leave.areaCodeAndName =
        obj.areaCode && obj.areaName ? obj.areaName + "/" + obj.areaCode : "";
      this.formValidate_leave.teamInfoCode = obj.teamInfoCode;
      this.formValidate_leave.teamName = obj.teamName;
      this.formValidate_leave.groupCode = obj.groupInfoCode;
      this.formValidate_leave.groupName = obj.groupInfoName;
      this.formValidate_leave.postCode = obj.postCode;
      this.formValidate_leave.postName = obj.postName;
      this.formValidate_leave.certificateNum = obj.certificateNum;
    },
  },
  computed: {
    transForList() {
      return this.companyList;
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById("moreCondition").style.display = "none";
      document.getElementById("upBtn").style.display = "none";
    });
  },
  watch: {
    "formValidate_leave.agentCode"(m, v) {
      if (m) {
        //可能遇到change之后表单的校验不清除  所有需要重置一下 并赋值
        this.$refs.formValidate_leave.fields.forEach((e) => {
          if (e.prop == "agentCode") {
            e.resetField();
            this.formValidate_leave.agentCode = m;
          }
        });
      }
    },
    formValidate_leave(m, v) {
      if (m && !m.quitCount) {
        m.quitCount = 0;
      }
      if (m) {
        if (m.deptName) {
          m.deptCodeAndName = m.deptName + "/" + m.deptCode;
        }
        if (m.areaName) {
          m.areaCodeAndName = m.areaName + "/" + m.areaCode;
        }
        if (m.rankName) {
          m.rankCodeAndName = m.rankName + "/" + m.rankCode;
        }
      }
    },
    //quitCount
  },
};
</script>

<style lang="less" scoped>
#quitApply {
  .header {
    display: -webkit-flex;
    display: flex;
    justify-content: space-around;
  }
  .ivu-input,
  .ivu-select,
  .ivu-date-picker {
    width: 162px;
  }
}
.fileStyle /deep/ .ivu-form-item-error-tip {
  display: none !important;
}
</style>
